import type { Admin } from "../types/auth";

export const canViewInstantMenu = (admin: Admin | null): boolean =>
  admin?.permissions?.nowMeals === true || admin?.permissions?.ops === true;

export const canViewDrinks = (admin: Admin | null): boolean =>
  admin?.role === "kitchen-staff" || admin?.permissions?.drinks === true;

export const canManageDrinks = (admin: Admin | null): boolean =>
  admin != null && admin.role !== "kitchen-staff" && admin.permissions?.drinks === true;

export const getDefaultRouteForPermissions = (
  permissions?: Record<string, boolean>
): string => {
  if (!permissions) {
    return "/dashboard";
  }

  const orderedPermissions: Array<{ key: string; path: string }> = [
    { key: "analytics", path: "/dashboard" },
    { key: "orders", path: "/orders" },
    { key: "meals", path: "/meals" },
    { key: "kitchens", path: "/kitchens" },
    { key: "subscriptions", path: "/subscriptions" },
    { key: "users", path: "/users" },
    { key: "discounts", path: "/discounts" },
    { key: "deliveryAgents", path: "/deliveryAgents" },
    { key: "holidays", path: "/holidays" },
    { key: "kitchens", path: "/kitchens" },
  ];

  const match = orderedPermissions.find(({ key }) => permissions[key]);

  return match ? match.path : "/dashboard";
};
